import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { ID, SuccessResponse } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useInviteIraUser = () => {
  const queryClient = useQueryClient();

  const mutate = async (id: ID) => {
    const { data } = await api.inviteIraUser(id);

    return data;
  };

  const mutationKey = MutationKeys.inviteIraUser;

  return useMutation<SuccessResponse, AxiosError<ApiError>, ID>(mutationKey, mutate, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.iraUsers);
      queryClient.invalidateQueries(QueryKeys.iraUser);
    },
  });
};
